import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { setPrevPage } from '../../../redux/slices/appStateSlice';

const DependentsLogic = ({ fields, params, deps }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const variant = params?.variant;
    const hasSpouse = deps?.spouse?.dateOfBirth;
    const childCount = deps?.children?.length || 0;

    let prevPage;

    if (childCount > 1) {
      prevPage = fields.childrenDetailsPage?.value?.href;
    } else if (childCount === 1) {
      prevPage = fields.childDetailsPage?.value?.href;
    } else if (hasSpouse) {
      prevPage = fields.partnerDetailsPage?.value?.href;
    } else {
      prevPage =
        variant === 'quote'
          ? fields.whoToCoverPage?.value?.href
          : fields.confirmDetailsPage?.value?.href;
    }

    dispatch(setPrevPage(prevPage));
  }, [deps]);

  return null;
};

const mapStateToProps = (state, props) => ({
  ...props,
  deps: state.quoteData?.prospectDetails?.dependents,
});

export default connect(mapStateToProps)(DependentsLogic);
